import { Injectable } from '@angular/core';
import { BenchmarkProfile } from '../core-data-model/BenchmarkProfile.model';
import {
    ProfileBehavioralInfoServer,
    BenchmarkProfileServerEntry
} from '../core-data-model/BenchmarkProfileApi.serverinterface';

@Injectable({
    providedIn: 'root'
})
export class BenchmarkProfileTransformers {
    transformFromServer(json: BenchmarkProfileServerEntry): BenchmarkProfile {
        const behavioralInfo: ProfileBehavioralInfoServer = {
            aSigma: json.behavioralInfo.aSigma,
            bSigma: json.behavioralInfo.bSigma,
            cSigma: json.behavioralInfo.cSigma,
            dSigma: json.behavioralInfo.dSigma,
            description: json.behavioralInfo.description,
            expectedBehaviors: json.behavioralInfo.expectedBehaviors,
            motivatingNeeds: json.behavioralInfo.motivatingNeeds,
            appealingWords: json.behavioralInfo.appealingWords,
            primaryBehaviorTrait1: json.behavioralInfo.primaryBehaviorTrait1,
            noteworthyBehaviors1: json.behavioralInfo.noteworthyBehaviors1,
            primaryBehaviorTrait2: json.behavioralInfo.primaryBehaviorTrait2,
            noteworthyBehaviors2: json.behavioralInfo.noteworthyBehaviors2,
            moreInfoLink: json.behavioralInfo.moreInfoLink
        };
        return new BenchmarkProfile({
            name: json.name,
            badgeUrl: json.badgeUrl,
            percent: json.percent,
            behavioralInfo: behavioralInfo
        });
    }
}
